import { render, staticRenderFns } from "./EsqueciSenha.vue?vue&type=template&id=2a4d0216"
import script from "./EsqueciSenha.vue?vue&type=script&lang=js"
export * from "./EsqueciSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4d0216')) {
      api.createRecord('2a4d0216', component.options)
    } else {
      api.reload('2a4d0216', component.options)
    }
    module.hot.accept("./EsqueciSenha.vue?vue&type=template&id=2a4d0216", function () {
      api.rerender('2a4d0216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EsqueciSenha.vue"
export default component.exports